import React from 'react'
import * as Yup from 'yup'

import { Button, Fieldset, ModalBox, RadioButton } from '@fourthwall/components'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import { useFormik } from '@fourthwall/utils/dist/formik'

export const ToggleStatusModal = ({
  onSubmit,
  close,
  getCount,
}: {
  getCount: () => number
  close: () => void
  onSubmit: (status: Offer.State['status']) => Promise<void>
}) => {
  const count = getCount()
  const formik = useFormik<{ status: Offer.State['status'] }>({
    initialValues: {
      status: 'PUBLIC',
    },
    onSubmit: async (values) => {
      await onSubmit(values.status)
      close()
    },
    validationSchema: Yup.object().shape({
      status: Yup.string().required(),
    }),
    enableReinitialize: true,
    validateOnMount: true,
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <ModalBox
        onClose={close}
        size="small"
        title={`Change status for ${count} ${count > 1 ? 'products' : 'product'}`}
        buttons={[
          <Button
            label="Cancel"
            appearance="secondary"
            onClick={close}
            disabled={formik.isSubmitting}
          />,
          <Button
            label="Update"
            appearance="primary"
            type="submit"
            loading={formik.isSubmitting}
          />,
        ]}
      >
        <Fieldset>
          <Fieldset.Row>
            <RadioButton
              value={formik.values.status}
              checkedValue="PUBLIC"
              label="Public"
              suggestion="Everyone has access."
              name="status"
              onChange={formik.handleChange}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <RadioButton
              value={formik.values.status}
              checkedValue="HIDDEN"
              label="Hidden"
              suggestion="Everyone with link has access."
              name="status"
              onChange={formik.handleChange}
            />
          </Fieldset.Row>
        </Fieldset>
      </ModalBox>
    </form>
  )
}
